/**
 * @file Textarea 多行输入
 * @description 紧凑多行文本；无 size API。
 *
 * @whenToUse 备注、描述、多行内容。
 * @whenNotToUse 单行字段（用 Input）。
 */

import type { TextareaHTMLAttributes } from 'react'
import { cn } from '@/lib/cn.ts'

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  /** 校验失败 */
  invalid?: boolean
}

export function Textarea({
  invalid = false,
  className,
  disabled,
  rows = 4,
  ...rest
}: TextareaProps) {
  return (
    <textarea
      rows={rows}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full resize-y rounded-lg border-2 bg-raised px-3 py-2 text-sm text-foreground transition-opacity duration-200 disabled:cursor-not-allowed disabled:opacity-50',
        invalid ? 'border-danger' : 'border-border',
        className,
      )}
      {...rest}
    />
  )
}
